import { byUserInteraction, libInit, sendGoogleEvent } from '@html/_common/utils';

export default function AOCenteredContactUs() {
  const openAskAQuestion = () => {
    import(/* webpackChunkName: "AskAQuestion" */'@html/_common/question/script').then((module) => {
      const AskAQuestion = module.default;
      const question = new AskAQuestion();
      question.startEnquiryDialog({
        id: -1,
        name: `CLP - ${window.location.pathname.substring(1)}`,
        forceEnqiry: true,
      });
    });
  };

  const onClickContactUs = () => {
    openAskAQuestion();

    sendGoogleEvent(
      'Ask A Question',
      'Ask a question open',
      `CLP - ${window.location.pathname.substring(1)}`,
      {
        ampEventName: 'ask_question_form_opened',
      },
    );
  };

  const initiate = () => {
    byUserInteraction('initiate-centered-contact-us', () => {
      libInit('popup', () => {
        const $contact = $('.js-ao-clp-centered-contact-us__button');
        $contact.click(onClickContactUs);
      });
    });
  };

  return { initiate };
}
